import { Serializer } from 'survey-core';

function isNotSubscale(obj: { subscale: boolean }): boolean {
  return !obj.subscale;
}

Serializer.addProperty('expression', {
  category: 'general',
  default: false,
  displayName: 'Subscale',
  name: 'subscale',
  type: 'boolean',
});

Serializer.addProperty('expression', {
  category: 'general',
  displayName: 'Thresholds',
  name: 'thresholds',
  type: 'itemvalues',
  visibleIf: isNotSubscale,
});

Serializer.addProperty('expression', {
  category: 'general',
  displayName: 'Maximum value',
  name: 'maxValue',
  type: 'number',
});

Serializer.addProperty('expression', {
  category: 'general',
  displayName: 'Condition name',
  name: 'conditionName',
  type: 'string',
  visibleIf: isNotSubscale,
});

Serializer.addProperty('expression', {
  category: 'general',
  displayName: 'Measure Name',
  name: 'measureName',
  type: 'string',
});

Serializer.addProperty('page', {
  category: 'general',
  default: false,
  displayName: 'Psyomics Table of Contents',
  name: 'psyomicsToc',
  type: 'boolean',
});

const serializerRegistered = true;

export { isNotSubscale, serializerRegistered };
